var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('base-task-status',{attrs:{"session_id":_vm.session.id,"task_name":"cost_method","finishedHook":_vm.handleTaskStatusFinished}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }